import { Labels } from '../labels';

const PRIVACY_POLICY_URL = 'https://fanatee.com/privacy-policy';
const TERMS_OF_SERVICE_URL = 'https://fanatee.com/terms-of-service';

export default function Footer() {
  return (
    <div className='footer'>
      <div className='footer-text'>{Labels.Footer.getValue()}</div>

      <div className='footer-links'>
        <a className='footer-link' href={PRIVACY_POLICY_URL}
          target='_blank' rel='noreferrer'>
          {Labels.PrivacyPolicy.getValue()}
        </a>

        <a className='footer-link' href={TERMS_OF_SERVICE_URL}
          target='_blank' rel='noreferrer'>
          {Labels.TermsOfService.getValue()}
        </a>
      </div>
    </div>
  );
}
